import { memo, type ReactNode } from 'react';

export type WorkspaceAgentPanelMarkdownLinkProps = {
  children: ReactNode;
  'data-testid': string;
  href: string | undefined;
};

/**
 * Every destination the agent writes into markdown, whether it wrote it as a link or as an image.
 * Anything it authors is untrusted, so the tab it opens gets no handle on this one.
 */
export const WorkspaceAgentPanelMarkdownLink = memo(
  ({ children, 'data-testid': testId, href }: WorkspaceAgentPanelMarkdownLinkProps) => (
    <a
      className="break-all ads:text-accent text-altitude-11 underline ads:hover:text-accent-hover hover:text-altitude-12 focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-altitude-8"
      data-testid={testId}
      href={href}
      rel="noopener noreferrer"
      target="_blank"
    >
      {children}
    </a>
  ),
);

WorkspaceAgentPanelMarkdownLink.displayName = 'WorkspaceAgentPanelMarkdownLink';
